import { Installer } from '../models/installer'

export const mockInstallers = [
  { id: 1, name: 'Lan Phan Installer' },
  { id: 2, name: 'Jimmy Installer' },
  { id: 3, name: 'Suleman Installer' },
] as Installer[]
